<template>
  <div class="top-alerts" v-if="isActive">
      <div class="top-alerts__container">
        <div
          class="top-alerts__item"
          v-if="draft"
        >
          <div
            class="draft__alert in m-0"
            :class="isMobile ? 'draft__alert__on__mobile' : 'draft__alert__on__events'"
          >
            <div class="draft__alert__block">
              <div class="draft__alert__message">
                <div class="draft__alert__text">
                  {{ $t('draft.message') }}
                  <a
                    :href="draft.eventUrl"
                    class="draft__alert__text__event">{{ draft.eventName }}
                  </a>
                </div>
              </div>
              <div class="draft__alert__action">
                <button
                  class="draft__alert__button draft__alert__button__delete"
                  @click="deleteDraft"
                >
                  <div class="draft__alert__button_text">{{ $t('draft.delete') }}</div>
                </button>
                <a
                  class="draft__alert__button draft__alert__button__continue"
                  :href="draft.registerLink"
                >
                  <div class="draft__alert__button_text">{{ $t('draft.continue') }} &gt;</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DraftAlert',
  data() {
    return {
      draft: this.$root.draft,
      isMobile: false,
    };
  },
  computed: {
    isActive() {
      return this.draft;
    },
  },
  methods: {
    deleteDraft() {
      if (!this.draft.isLocal) {
        axios.post('/Register/ApiClearCart');
      }
      localStorage.removeItem('registerDraft');
      this.draft = null;
      this.$root.draft = null;
    },
    getDraft() {
      axios.get('/Register/ApiCardInfo')
        .then((response) => {
          const res = response.data;
          if (res.HasDraft) {
            this.draft = {
              isLocal: false,
              eventUrl: res.Draft.EventUrl,
              eventName: res.Draft.EventName,
              registerLink: res.Draft.RegistrationUrl,
            };
          } else {
            const serialized = localStorage.getItem('registerDraft');
            if (!serialized) {
              return;
            }
            const draft = JSON.parse(serialized);
            const forCurrentUser = window.userInfo.Id === draft.userId;
            if (!forCurrentUser) {
              localStorage.removeItem('registerDraft');
              return;
            }
            this.draft = {
              isLocal: true,
              eventUrl: `/event/${draft.eventCode}`,
              eventName: draft.eventName,
              registerLink: `/${draft.eventCode}/${draft.raceCode}/Register`,
            };
          }
          this.$root.draft = this.draft;
        });
    },
  },
  created() {
    if (window.userInfo) {
      this.getDraft();
    }
  },
  mounted() {
    this.isMobile = document.body.className.indexOf('mobile-mode') !== -1;
  },
};
</script>

<style lang="scss">
.top-alerts {
  margin: 24px 0;

  &__container {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    margin-top: -12px;
  }

  .top-alerts__item {
    margin-top: 12px;
  }

  .draft__alert_text {
    line-height: 1.3em;
  }

  .draft__alert__button {
    padding: 1px 6px;
    text-align: center;
  }

  .alert {
    margin: 0;
  }
}
</style>
